export default __webpack_public_path__ + "static/open-sans-latin-600-normal-0887b7d317f32a6a0d991108d62d2be1.woff2";